import { memo } from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { TranslateLanguage } from '../general/navigation/translate'
import { ProfileInputCell } from '../general/cells/profile-input'
import { User } from '@app/types'

const LanguageViewComponent = ({
  onChangeLanguage,
  user,
  loading,
}: {
  onChangeLanguage(n: string): Promise<void>
  user?: User
  loading?: boolean
}) => {
  const { t, lang } = useTranslation()

  return (
    <ProfileInputCell
      title={t('settings:language')}
      subTitle={t('settings:language-pref')}
      skeletonLoad={!user && loading}
      submitLabel={{
        title: `${t('settings:cu-language')} ${
          lang ? t(`lang:${lang}`) : lang
        }`,
        submit: (
          <TranslateLanguage onChangeLanguage={onChangeLanguage} noicon />
        ),
      }}
    />
  )
}

export const LanguageView = memo(LanguageViewComponent)
